import { createAsyncThunk } from '@reduxjs/toolkit';
import Endpoints from 'constants/endpoints';
import { CreateToDoPayload } from 'interfaces';
import focusBearApi from 'services/axios-config';
import {
  updateIsGeneratingSubtasks,
  updateIsUpdatingSubTaskStatus,
  updateTodoSubTasks
} from './slice';
import { HTTP_STATS_CODE } from 'constants/general';
import { toast } from 'react-toastify';
import { t } from 'services/i18n.service';
import { RootState } from 'store';
import { updateTasks } from '../to-do/slice';
import { captureException } from 'services/posthog.service';
import { getApiLanguageCode } from 'utils/helpers';

export const generateSubTasks = createAsyncThunk(
  'modal/generate_subtasks',
  async (payload: { task: string; language: string }, { dispatch }) => {
    try {
      dispatch(updateIsGeneratingSubtasks(true));
      const { status, data } = await focusBearApi.post(
        Endpoints.TO_DO_GENERATE_SUBTASKS,
        {
          ...payload,
          language: getApiLanguageCode(payload.language)
        }
      );
      status === HTTP_STATS_CODE.CREATED
        ? toast.success(
            t('to_do_procrastinate.subtasks_generated_successfully')
          )
        : toast.error(t('to_do_procrastinate.could_not_generate_subtasks'));
      return data ?? { subtasks: [] };
    } catch (error) {
      dispatch(updateIsGeneratingSubtasks(false));
      captureException(error);
      toast.error(t('to_do_procrastinate.could_not_generate_subtasks'));
    }
  }
);

export const updateSubTaskStatus = createAsyncThunk(
  'modal/update_sub_task_status',
  async (payload: CreateToDoPayload, { dispatch, getState }) => {
    try {
      const { tasks } = (getState() as RootState).toDo;
      dispatch(updateIsUpdatingSubTaskStatus(true));
      const { status } = await focusBearApi.put(Endpoints.TO_DO, payload);
      dispatch(updateIsUpdatingSubTaskStatus(false));
      if (status === HTTP_STATS_CODE.SUCCESS) {
        const updatedTasks = tasks.map((task) =>
          task.id === payload.id ? payload : task
        );
        dispatch(updateTasks(updatedTasks));
      } else {
        const task = tasks.find((task) => task.id === payload.id);
        task && dispatch(updateTodoSubTasks({ subTasks: task.subtasks ?? [] }));
        toast.error(t('to_do_procrastinate.could_not_update_the_task'));
      }
    } catch (error) {
      dispatch(updateIsUpdatingSubTaskStatus(false));
      captureException(error);
    }
  }
);
